"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AnimationFactory = require("./AnimationFactory");

Object.keys(_AnimationFactory).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AnimationFactory[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AnimationFactory[key];
    }
  });
});